import React from "react";
import { Link } from "react-router-dom";
import ProjectsSection from "../../components/ProjectsSection";
import Testimonials from "../../components/Testimonials";

const AIIntegrations = () => {

  const projects = [
    { title: "AI Chatbot System", desc: "Automated customer support.", link: "#" },
  ];

  const testimonials = [
    { name: "Tech Founder", role: "CEO", feedback: "AI automation saved us hours daily." },
  ];

  return (
    <div className="text-white bg-black overflow-hidden">

      {/* HERO */}
      <section className="relative min-h-screen flex items-center justify-center text-center px-6">
        <div className="absolute w-[600px] h-[600px] bg-teal-500/30 blur-[140px]"></div>

        <div className="relative z-10 max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-extrabold">
            Smart <span className="text-teal-400">AI Integration</span>
          </h1>

          <p className="mt-6 text-gray-300 max-w-2xl mx-auto">
            Automate workflows, enhance decisions, and scale faster with AI.
          </p>

          <div className="mt-10 flex gap-4 justify-center">
            <Link to="/contact" className="bg-teal-500 px-8 py-4 rounded-full">
              Integrate AI
            </Link>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="py-24 grid md:grid-cols-3 gap-8 max-w-6xl mx-auto px-6">
        {["Chatbots","Automation","AI APIs","CRM AI","Analytics","NLP"].map((i)=>(
          <div key={i} className="bg-white/5 p-6 rounded-xl border border-white/10 hover:scale-105 transition">
            <h3 className="text-teal-400">{i}</h3>
          </div>
        ))}
      </section>

      {/* PROCESS */}
      <section className="py-24 text-center bg-[#0b1a35]">
        <h2 className="text-4xl font-bold mb-12">Our AI Process</h2>
        <div className="grid md:grid-cols-4 gap-8">
          {["Analyze","Design","Integrate","Optimize"].map((step,i)=>(
            <div key={i}>
              <div className="text-teal-400 text-2xl font-bold">{i+1}</div>
              <p>{step}</p>
            </div>
          ))}
        </div>
      </section>

      <ProjectsSection projects={projects} />
      <Testimonials testimonials={testimonials} />

      <section className="py-28 text-center bg-gradient-to-r from-teal-500 to-blue-500">
        <h2 className="text-4xl font-bold">Transform with AI 🤖</h2>
      </section>

    </div>
  );
};

export default AIIntegrations;